import React from 'react';

const NewsManagement: React.FC = () => {
  return (
    <div className="news-management">
      <h1>News verwalten</h1>
      <p>Erstellen und Bearbeiten von System-News und Aktionen.</p>
    </div>
  );
};

export default NewsManagement;
